import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { StateToObj } from "./reduxHelper";

const initialState = {
    "id" : uuidv4(),
    "data": [],
    "totalMessage": 0
}

const forwardMessageData = createSlice({
    name:'forwardMessageData',
    initialState,
    reducers:{
        addForwardMessageData: (state = initialState,payload = {})=>{  
            const { id, data } = StateToObj(state)
            const updatedArray = [payload.payload, ...data]   
               return {
                ...state,
                ...{
                    "id" : id,
                    "data": updatedArray,
                    "totalMessage": updatedArray.length
                }
               }
        },
        removeForwardMessageData:(state,payload)=>{
            const { id, data } = StateToObj(state)
            const filterMessage = data.filter(ele => ele.msgId !== payload.payload)
            return {
                ...state,
                id,
                data: filterMessage,
                totalMessage: filterMessage.length
            }
        },
        resetForwardMessage: (state ,payload)=>{
            return initialState
        }
    }
});

export default forwardMessageData.reducer
export const addForwardMessageData = forwardMessageData.actions.addForwardMessageData
export const removeForwardMessageData = forwardMessageData.actions.removeForwardMessageData
export const resetForwardMessage = forwardMessageData.actions.resetForwardMessage